module.exports = "<div class=\"employees-container bg-light-soft\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"hpanel\">\n        <div class=\"panel-body\">\n          <spring-data-table\n            rest-url=\"admin/payroll\"\n            columns=\"$ctrl.customerColumns\"\n            filter=\"$ctrl.filterCriteria\"\n            filterrefresh=\"$ctrl.filterrefresh\"\n          ></spring-data-table>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/admin/payroll/payroll.html
// module id = 1010
// module chunks = 0